import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { ContactReportService, ToasterLibraryService, AppConfig } from '@service/index';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-contact-gross-profit-count-widget',
  templateUrl: './contact-gross-profit-count-widget.component.html',
  styleUrls: ['./contact-gross-profit-count-widget.component.scss']
})

// @Privilege({
//   privilege: 'emailtemplates:can_get_emailtemplates_reports_sent'
// })
export class ContactGrossProfitCountWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any = '';
  @Input() criteriaArray: any;
  @Input() campaignData: any;
  @Input() formData: any;
  @Input() priceData: any;
  public isCountLoaded = false;
  public totalGrossProfit: any = 0;
  public currencyCode: string;
  public currencyPrecision: string | number;
  public appContactSoldOptions = AppConfig.contactSoldOptions;
  @Input() widgetTitle = 'Net Profit';
  constructor(
    private contactReportService: ContactReportService,
    private toasterLibrary: ToasterLibraryService,
    private permissionService: NgxPermissionsService
  ) { }
  ngOnInit() {
    if (this.permissionService.hasPermission('contacts:can_get_contacts_gross_profit')) {
      this.criteriaArray = JSON.parse(localStorage.getItem('leadsCriteria'));
      // console.log(this.criteriaArray);
      this.requestContactsSoldCount();
    }
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (this.permissionService.hasPermission('contacts:can_get_contacts_gross_profit')) {
      if (
        (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) ||
        (changes['campaignData'] && !changes['campaignData'].isFirstChange()) ||
        (changes['criteriaArray'] && !changes['criteriaArray'].isFirstChange()) ||
        (changes['priceData'] && !changes['priceData'].isFirstChange()) ||
        (changes['formData'] && !changes['formData'].isFirstChange())
      ) {
        this.requestContactsSoldCount();
      }
    }
  }

  requestContactsSoldCount() {
    const criteriaArray: any = this.getCommonCriteria() || [];

    this.isCountLoaded = false;
    this.contactReportService.getContactsGrossProfit(criteriaArray)
      .subscribe((res: any) => {
        this.totalGrossProfit = res.data.gross_profit.reduce((total, item) => total + Number(item.gross_profit), 0);
        this.currencyCode = res.data.currency_code;
        this.currencyPrecision = res.data.currency_precision;
        this.isCountLoaded = true;
      });
  }

  private getCommonCriteria() {
    const criteriaArray: any = [
      {
        is_required: true,
        criterion: 'dateRange',
        value: {
          relative_date: this.relativeDate
        }
      }
    ];

    if (this.campaignData && this.campaignData != "") {
      criteriaArray.push({
        'id': '',
        'value': { c_id: this.campaignData },
        'criterion': 'campaign',
        'is_required': true
      });
    }

    if (this.formData && this.formData != "") {
      criteriaArray.push({
        value: [this.formData],
        criterion: 'form',
        is_required: true,
        id: ''
      });
    }

    if (this.priceData && this.priceData != "") {
      criteriaArray.push({
        value: { rprice_id: this.priceData },
        criterion: 'leadPricing',
        is_required: true,
        id: 0
      });
    }
    return criteriaArray;
  }
}
